import { Plus, Trash2 } from "lucide-react";
import { ImageInput } from "./ImageInput";
import { useCollection } from "./useCollection";

export default function ServicesAdmin() {
  const { items, setItems, create, save, remove } = useCollection("services");
  const update = (id, k, v) => setItems((xs) => xs.map((x) => (x.id === id ? { ...x, [k]: v } : x)));
  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="font-display text-4xl font-black uppercase">Services</h1>
        <button className="btn-red !py-2" onClick={() => create({ title: "New Service", description: "", image: "", order: items.length })} data-testid="admin-add-service-button"><Plus className="h-4 w-4" />Add Service</button>
      </div>
      <div className="mt-6 grid gap-5 xl:grid-cols-2">
        {items.map((s, i) => (
          <div key={s.id} className="panel space-y-3 p-5" data-testid={`admin-service-${i}`}>
            <ImageInput value={s.image} onChange={(v) => update(s.id, "image", v)} testId={`admin-service-image-${i}`} />
            <div className="grid grid-cols-[1fr_90px] gap-3">
              <div><label className="label">Title</label><input className="field" value={s.title} onChange={(e) => update(s.id, "title", e.target.value)} data-testid={`admin-service-title-${i}`} /></div>
              <div><label className="label">Order</label><input className="field" type="number" value={s.order} onChange={(e) => update(s.id, "order", parseInt(e.target.value, 10) || 0)} data-testid={`admin-service-order-${i}`} /></div>
            </div>
            <div><label className="label">Description</label><textarea className="field min-h-[80px]" value={s.description} onChange={(e) => update(s.id, "description", e.target.value)} data-testid={`admin-service-description-${i}`} /></div>
            <div className="flex justify-between">
              <button onClick={() => window.confirm("Delete this service?") && remove(s.id)} className="flex items-center gap-1 text-sm text-slate-500 hover:text-red-400" data-testid={`admin-service-delete-${i}`}><Trash2 className="h-4 w-4" />Delete</button>
              <button onClick={() => save(s)} className="btn-red !py-2 !text-base" data-testid={`admin-service-save-${i}`}>Save</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
